const protocolPattern = /^[a-z][a-z\d+.-]*:/i;

export type ValidatedLocalRoute = string & { readonly __validatedLocalRoute: unique symbol };

export const toValidatedLocalRoute = (route: string): ValidatedLocalRoute => route as ValidatedLocalRoute;

export const parseValidatedLocalRoute = (route: string | undefined): ValidatedLocalRoute | undefined => {
	if (!route) {
		return undefined;
	}

	try {
		const decodedRoute = decodeURIComponent(route);

		if (!decodedRoute.startsWith("/") || decodedRoute.startsWith("//") || protocolPattern.test(decodedRoute)) {
			return undefined;
		}

		return decodedRoute as ValidatedLocalRoute;
	} catch {
		return undefined;
	}
};
